import { WIDEO_BRAND } from "src/editor/core/EditorConstants";

export function _isWideoBrand(context: { brandName?: string } | null): boolean {
    const brandName = context?.brandName || WIDEO_BRAND;
    return brandName === WIDEO_BRAND;
}
